import type { DestinationContext, TrackingDestination } from '../types'
import { getCustomerIoAnalytics } from '@/MainLayout/CustomerIoCdp'

export class CustomerIoDestination implements TrackingDestination {
  public readonly key = 'customerIo' as const
  // Match old/current site behavior: Customer.io is not gated behind CookieYes statistics consent.
  public readonly requiredConsent = null

  init() {
    // Initialize/load when configured. (CookieYes gating intentionally not applied.)
    void getCustomerIoAnalytics()
  }

  identify(userId: string, traits?: Record<string, any>, ctx?: DestinationContext) {
    const cio = getCustomerIoAnalytics()
    if (!cio) return
    try {
      const customerId = traits?.customerId ?? ctx?.identity.customerId
      const email =
        ctx?.identity.email ?? (userId.includes('@') ? userId : undefined)
      const customerIoUserId =
        customerId != null && String(customerId).trim() !== ''
          ? String(customerId)
          : userId
      const customerIoTraits = { ...(traits || {}) }
      if (email && !customerIoTraits.email) {
        customerIoTraits.email = email
      }

      // Match the old site: Customer.io profile id is the numeric customer id when available.
      cio.identify(customerIoUserId, customerIoTraits)
    } catch {
      // Non-fatal
    }
  }

  track(eventName: string, properties?: Record<string, any>) {
    const cio = getCustomerIoAnalytics()
    if (!cio) return
    try {
      cio.track(eventName, properties || {})
    } catch {
      // Non-fatal
    }
  }

  page(path: string, properties?: Record<string, any>) {
    const cio = getCustomerIoAnalytics()
    if (!cio) return
    try {
      cio.page(path, properties || {})
    } catch {
      // Non-fatal
    }
  }
}
